import styled from 'styled-components'
import Description from '../../components/Description/Description'
import Title from '../../components/Title/Title'
import Box from '../../components/Box/Box'
import infoImg from '../../images/info-img.jpg'
import eyeStrain from '../../images/icons/eye-strain.svg'
import properSleep from '../../images/icons/proper-sleep.svg'
import blueLight from '../../images/icons/blue-light.svg'

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 50px 0;
`
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
`
const Grid1 = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 50px;
`
const Image = styled.img`
  border-radius: 10px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.5);
  width: 100%;
`
const Grid3 = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 50px;
  text-align: left;
`
const BoxTitle = styled.h2`
  margin: 0;
`
const BoxDescription = styled.p`
  margin: 0;
`
const Icon = styled.img``
const BoxWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 50px;
`

export default function Info() {
  return (
    <Container>
      <div className="container">
        <Wrapper>
          <Grid1>
            <Title title="Beautiful dark mode" />
            <Description description="It looks outstanding, and it's outstanding. Dark theme with not inverted colors." />
            <Image src={infoImg} alt="GDark Preview" />
            <Grid3 className="info__grid3">
              <Box>
                <BoxWrapper>
                  <Icon src={eyeStrain} alt="Eye strain" />
                  <BoxTitle>Reduces Eye Strain</BoxTitle>
                  <BoxDescription>
                    Your eyes will thank you when writing in such a beautiful
                    dark mode.
                  </BoxDescription>
                </BoxWrapper>
              </Box>
              <Box>
                <BoxWrapper>
                  <Icon src={properSleep} alt="Proper sleep" />
                  <BoxTitle>Get proper sleep</BoxTitle>
                  <BoxDescription>
                    Sleep better thanks to using a precisely created elegant
                    dark theme.
                  </BoxDescription>
                </BoxWrapper>
              </Box>
              <Box>
                <BoxWrapper>
                  <Icon src={blueLight} alt="Blue light" />
                  <BoxTitle>Eliminate blue light</BoxTitle>
                  <BoxDescription>
                    Save your eyes by eliminating the harmful blue light with
                    the help of GDark!
                  </BoxDescription>
                </BoxWrapper>
              </Box>
            </Grid3>
          </Grid1>
        </Wrapper>
      </div>
    </Container>
  )
}
